import ConfigurationCollection from '@app/src/pages/Configurations/ConfigurationCollection'
import AddCategory from '@app/src/pages/Configurations/ConfigurationsPages/SustainabilityLibraryTags/AddCategory'
import AddLibraryTag from '@app/src/pages/Configurations/ConfigurationsPages/SustainabilityLibraryTags/AddLibraryTag'
import RenameCategory from '@app/src/pages/Configurations/ConfigurationsPages/SustainabilityLibraryTags/RenameCategory'
import { Box, Divider } from '@mui/material'
import React from 'react'

const SustainabilityLibraryTags: React.FC = () => {
  return (
    <ConfigurationCollection enablePadding={{ right: true }}>
      <Box sx={{ width: '100%', maxWidth: 1200 }}>
        <AddLibraryTag />
        <Divider sx={{ my: 4 }} />
        <AddCategory />
        <Divider sx={{ my: 4 }} />
        <RenameCategory />
      </Box>
    </ConfigurationCollection>
  )
}

export default SustainabilityLibraryTags
